import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
import VersionHistory from 'src/components/common/VersionHistory';
import { archLevel } from 'src/data/config';
import { DataTable } from '@pihealth/common-ui-library';
import staticData from '../../../../resources/static.json';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useSIVConfirmationLetter } from './useSIVConfirmationLetter';
import SIVConfirmationLetter from './SIVConfirmationLetter';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
export default function DataGridSIVConfirmationLetter(props: any) {
  const { siteStudyPersonnelsData, sivVisitData, sivLetterData, setSIVConfirmLetterOpen, setStudyLogOpen } = props;
  const isHierarchyLevelClosed: boolean = useAppSelector(state => state.site.isHierarchyLevelClosed);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [headerTitle, setHedertitle] = useState('');
  const [showVersionHistory, setShowVersionHistory] = useState(false);
  const [docId, setDocId] = useState('');
  const dispatch = useAppDispatch();
  const assignedColoumns = staticData.SQLetters.columns;
  const [openSIVConfLetter, setopenSIVConfLetter] = useState(false);
  const [viewNTFGrid, setNTFGrid] = useState(true);
  const [rows, setRows] = useState([]);
  const { userPreferedDateFormat, getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const { checkPermission } = usePermissionWrapper();

  const { getSivConfrimationLetter, sivConfrimationLetterData, sivConfrimationLetterIsLoading } =
    useSIVConfirmationLetter();

  const handelBack = () => {
    setStudyLogOpen(true);
  };

  const [selectedRow, setselectedRow] = useState<any>(null);

  useEffect(() => {
    if (checkPermission('view_si_confirmationletter') && viewNTFGrid) {
      getSivConfrimationLetter({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry
      });
    }
  }, [viewNTFGrid, selectedSite, selectedCountry]);

  useEffect(() => {
    if (sivConfrimationLetterData) {
      setRows(
        sivConfrimationLetterData?.map((item: any) => {
          return {
            ...item,
            major_version: Number(item.major_version).toFixed(1).toString(),
            updated_on: getPreferredDateTimeInLocal(item.updated_on),
            start_date: getPreferredDateTimeInLocal(item.start_date)
          };
        })
      );
    }
  }, [sivConfrimationLetterData]);

  useEffect(() => {
    if (selectedSite === null) {
      handelBack();
    }
  }, [studyId, selectedCountry, selectedSite]);

  const handleClick = (row: any) => {
    if (archLevel === 'site') {
      if (row.major_version === '0.0') {
        dispatch(setMessage({ msgDetails: `${row.visit_name} not yet published`, severity: 'error' }));
      } else {
        if (!isHierarchyLevelClosed) {
          setopenSIVConfLetter(true);
          setNTFGrid(false);
          setselectedRow(row);
        } else {
          dispatch(setMessage({ msgDetails: 'Please select the site', severity: 'error' }));
        }
      }
    } else {
      if (!isHierarchyLevelClosed) {
        setopenSIVConfLetter(true);
        setNTFGrid(false);
        setselectedRow(row);
      } else {
        dispatch(setMessage({ msgDetails: 'Please select the site', severity: 'error' }));
      }
    }
  };

  const versionClick = (versionData: any) => {
    setHedertitle(versionData.visit_name);
    setDocId(versionData.tp_document_id);
    setShowVersionHistory(true);
  };

  const actions = {
    visit_name: (data: any) => {
      handleClick(data);
    },
    major_version: (data: any) => {
      versionClick(data);
    }
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `${`SIV Confirmation Letters`} ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };

  return (
    <div>
      {viewNTFGrid ? (
        <>
          <div>
            <Box sx={{ marginBottom: 1, mt: -1}}>
              <Button
                className="mainBackBtnWrap"
                onClick={() => handelBack()}
                startIcon={<ArrowBackIcon fontSize="small" />}
              >
                LIST OF LOGS
              </Button>
            </Box>
          </div>

          <div style={{ height: '74vh', width: '100%' }}>
            <div style={{ display: 'flex', height: '100%' }}>
              <div style={{ flexGrow: 1 }}>
                <DataTable
                  columns={assignedColoumns}
                  rows={rows}
                  loading={sivConfrimationLetterIsLoading}
                  disableSelectionOnClick={false}
                  pagination
                  className="studylogDatagrid"
                  exportAll
                  actions={actions}
                  datePreference={userPreferedDateFormat}
                  height="74vh"
                  hasDefinedDataGridToolbarExport
                  definedGridToolbarExport={definedCustomDatGridExport}
                />
              </div>
            </div>
          </div>
        </>
      ) : null}

      {openSIVConfLetter ? (
        <SIVConfirmationLetter
          siteStudyPersonnelsData={siteStudyPersonnelsData}
          sivVisitData={sivVisitData}
          sivLetterData={sivLetterData}
          setSIVConfirmLetterOpen={setSIVConfirmLetterOpen}
          setStudyLogOpen={setStudyLogOpen}
          selectedRow={selectedRow}
          setNTFGrid={setNTFGrid}
          setopenSIVConfLetter={setopenSIVConfLetter}
        />
      ) : null}
      {showVersionHistory ? (
        <VersionHistory
          openVersoinHistory={showVersionHistory}
          setOpenVersoinHistory={setShowVersionHistory}
          title={headerTitle}
          documentId={docId}
          auditModuleSection={'STUDY LOGS'}
        />
      ) : null}
    </div>
  );
}
